import React from 'react';

const GitLabIcon = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "28",
    height: "26",
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("g", { id: "Group 2" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.9853 23.6374L16.3129 24.6231V23.3268L16.0202 23.0298H13.9178V24.5421V25.6087H16.1665L18.9341 24.3935L19.9853 23.6374Z",
      fill: "#CDBDB2"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_2",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.00769 23.6374L11.6003 24.6231V23.3268L11.9063 23.0298H13.9953V24.5421V25.6087H11.7466L8.97897 24.3935L8.00769 23.6374Z",
      fill: "#CDBDB2"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_3",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.0248 20.8272L16.3175 23.3253L15.9449 23.0282H12.0596L11.6072 23.3253L11.9132 20.8272L12.512 20.4492L15.5058 20.5168L16.0248 20.8272Z",
      fill: "#393939"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_4",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.0409 3.88086L16.2446 8.13422L15.4197 20.516H12.5056L11.6008 8.13422L9.95093 3.88086H18.0409Z",
      fill: "#F89C35"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_5",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25.8911 13.2255L27.9934 19.3827L22.7509 19.0721H19.3845V16.4121L19.5309 10.957L20.2893 11.5512L25.8911 13.2255Z",
      fill: "#F89D35"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_6",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.9267 13.9146L15.7927 14.063L16.4713 17.2496L19.3853 16.4935L21.9267 13.9146Z",
      fill: "#D87C30"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_7",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.922 13.9805L19.3806 16.4109V18.8413L21.922 13.9805Z",
      fill: "#EA8D3A"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_8",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.3808 16.49L16.387 17.2461L15.4156 20.5137L16.0943 20.8918L19.3808 18.9204V16.49Z",
      fill: "#F89D35"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_9",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.3895 18.9233L19.9884 23.6357L16.0232 20.8272L19.3895 18.9233Z",
      fill: "#EB8F35"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_10",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.7918 14.0625L15.4197 20.5167L16.5362 17.2221L15.7918 14.0625Z",
      fill: "#EA8E3A"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_11",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22.8307 19.0044L19.3845 18.9233L19.9833 23.6357L22.8307 19.0044Z",
      fill: "#D87C30"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_12",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.3502 25.684L19.99 23.6316L22.8374 19.0002L28.0001 19.3783L26.3502 25.684Z",
      fill: "#EB8F35"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_13",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.2451 8.13525L19.4651 10.8762L21.9267 13.9143L15.7927 14.1439L16.2451 8.13525Z",
      fill: "#E8821E"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_14",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.9884 23.6348L16.0232 20.8262L16.3159 23.2567V24.6204L19.017 24.0938L19.9884 23.6348Z",
      fill: "#DFCEC3"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_15",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.00769 23.6348L11.9063 20.8262L11.6003 23.2567V24.6204L8.91248 24.0938L8.00769 23.6348Z",
      fill: "#DFCEC3"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_16",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.4458 15.4238L16.6208 17.1792L19.5348 16.4095L17.4458 15.4238Z",
      fill: "#393939"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_17",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.4249 0.315918L16.2458 8.13385L17.9623 3.88058L26.4249 0.315918Z",
      fill: "#E88F35"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_18",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M26.4241 0.315918L27.768 4.48818L27.0228 9.05203L27.5417 9.34914L26.7966 10.0377L27.3953 10.5643L26.5704 11.3205L27.0893 11.7795L25.8918 13.2918L20.2767 11.5501C17.5357 9.3221 16.1785 8.18792 16.2317 8.13385C16.285 8.07987 19.6912 5.4739 26.4241 0.315918Z",
      fill: "#8E5A30"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_19",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.10207 13.2255L-0.000244141 19.3827L5.24225 19.0721H8.60866V16.4121L8.4623 10.957L7.71717 11.5512L2.10207 13.2255Z",
      fill: "#F89D35"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_20",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.07202 13.9146L12.206 14.063L11.5408 17.2496L8.61343 16.4935L6.07202 13.9146Z",
      fill: "#D87C30"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_21",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.07202 13.9805L8.61343 16.4109V18.8413L6.07202 13.9805Z",
      fill: "#EA8D3A"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_22",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.61304 16.49L11.6068 17.2461L12.5782 20.5137L11.9129 20.8918L8.61304 18.9204V16.49Z",
      fill: "#F89D35"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_23",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.60654 18.9233L8.00769 23.6357L11.9064 20.8947L8.60654 18.9233Z",
      fill: "#EB8F35"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_24",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.2032 14.0625L12.5753 20.5167L11.4587 17.2221L12.2032 14.0625Z",
      fill: "#EA8E3A"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_25",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.16174 19.0044L8.60804 18.9233L8.00927 23.6357L5.16174 19.0044Z",
      fill: "#D87C30"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_26",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.64967 25.684L8.0099 23.6316L5.16246 19.0002L-0.000244141 19.3783L1.64967 25.684Z",
      fill: "#EB8F35"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_27",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7536 8.13525L8.53365 10.8762L6.07202 13.9143L12.206 14.1439L11.7536 8.13525Z",
      fill: "#E8821E"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_28",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5575 15.4238L11.3824 17.1792L8.46851 16.4095L10.5575 15.4238Z",
      fill: "#393939"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_29",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.56812 0.315918L11.7471 8.13385L10.0306 3.88058L1.56812 0.315918Z",
      fill: "#E88F35"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_30",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.57411 0.315918L0.230225 4.48818L0.975352 9.05203L0.456467 9.34914L1.20159 10.0377L0.602832 10.5643L1.42775 11.3205L0.908862 11.7795L2.10639 13.2918L7.72149 11.5501C10.4625 9.3221 11.8196 8.18792 11.7665 8.13385C11.7132 8.07987 8.32025 5.4739 1.57411 0.315918Z",
      fill: "#8E5A30"
    }
  ))
);

export { GitLabIcon };
//# sourceMappingURL=GitLabIcon.js.map
